var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0095 4.30177C13.9362 4.1951 12.8628 4.1151 11.7828 4.0551V4.04844L11.6362 3.18177C11.5362 2.56844 11.3895 1.64844 9.8295 1.64844H8.08283C6.5295 1.64844 6.38283 2.52844 6.27617 3.1751L6.13617 4.02844C5.51617 4.06844 4.89617 4.10844 4.27617 4.16844L2.91617 4.30177C2.63617 4.32844 2.43617 4.5751 2.46283 4.84844C2.4895 5.12177 2.7295 5.32177 3.0095 5.2951L4.3695 5.16177C7.86283 4.8151 11.3828 4.94844 14.9162 5.30177C14.9362 5.30177 14.9495 5.30177 14.9695 5.30177C15.2228 5.30177 15.4428 5.10844 15.4695 4.84844C15.4895 4.5751 15.2895 4.32844 15.0095 4.30177Z",
    fill: "url(#paint0_linear_3561_18961)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7828 6.24438C13.6228 6.07771 13.4028 5.98438 13.1761 5.98438H4.74947C4.52281 5.98438 4.29614 6.07771 4.14281 6.24438C3.98947 6.41104 3.9028 6.63771 3.91614 6.87104L4.32947 13.711C4.40281 14.7244 4.49614 15.991 6.82281 15.991H11.1028C13.4295 15.991 13.5228 14.731 13.5961 13.711L14.0095 6.87771C14.0228 6.63771 13.9361 6.41104 13.7828 6.24438ZM10.0695 12.651H7.84947C7.57614 12.651 7.34947 12.4244 7.34947 12.151C7.34947 11.8777 7.57614 11.651 7.84947 11.651H10.0695C10.3428 11.651 10.5695 11.8777 10.5695 12.151C10.5695 12.4244 10.3428 12.651 10.0695 12.651ZM10.6295 9.98438H7.29614C7.02281 9.98438 6.79614 9.75771 6.79614 9.48438C6.79614 9.21104 7.02281 8.98438 7.29614 8.98438H10.6295C10.9028 8.98438 11.1295 9.21104 11.1295 9.48438C11.1295 9.75771 10.9028 9.98438 10.6295 9.98438Z",
    fill: "url(#paint1_linear_3561_18961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3561_18961",
    x1: 8.96566,
    y1: 1.64844,
    x2: 8.96566,
    y2: 5.30177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3561_18961",
    x1: 8.9628,
    y1: 5.98437,
    x2: 8.9628,
    y2: 15.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSession);
export default __webpack_public_path__ + "static/media/delete-session.b0343bb5e4ea4e91b0d22e6d88dc0090.svg";
export { ForwardRef as ReactComponent };